<template>
  <div class="dashboard-container">
    <el-row :gutter="20" class="home-card-one">
      <el-col
        :span="6"
        class="mb-15"
        :xs="24"
        :sm="12"
        :md="12"
        :lg="6"
        :xl="6"
      >
        <div
          class="home-card-item flex"
          style="cursor: pointer"
          @click="toPage('/resources/detail?state=1')"
        >
          <div class="flex w100">
            <div class="flex-auto" style="color: #409eff">
              <span class="font30">{{ data.ResourcesReviewCount }}</span>
              <div class="mt10">待审资源</div>
            </div>
            <div class="home-card-item-icon flex">
              <div class="home-card-item-icon flex" style="background: #fef0f0">
                <i
                  class="flex-margin el-icon-s-cooperation font32"
                  style="color: #f56c6c"
                ></i>
              </div>
            </div>
          </div>
        </div>
      </el-col>
      <el-col
        :span="6"
        class="mb-15"
        :xs="24"
        :sm="12"
        :md="12"
        :lg="6"
        :xl="6"
      >
        <div
          class="home-card-item flex"
          style="cursor: pointer"
          @click="toPage('/project/detail?state=1')"
        >
          <div class="flex w100">
            <div class="flex-auto" style="color: #409eff">
              <span class="font30">{{ data.ProjectReviewCount }}</span>
              <div class="mt10">待审项目招商</div>
            </div>
            <div class="home-card-item-icon flex">
              <div class="home-card-item-icon flex" style="background: #fdf6ec">
                <i
                  class="flex-margin el-icon-s-claim font32"
                  style="color: #e6a23c"
                ></i>
              </div>
            </div>
          </div></div
      ></el-col>
      <el-col
        :span="6"
        class="mb-15"
        :xs="24"
        :sm="12"
        :md="12"
        :lg="6"
        :xl="6"
      >
        <div
          class="home-card-item flex"
          style="cursor: pointer"
          @click="toPage('/activity/detail?state=0')"
        >
          <div class="flex w100">
            <div class="flex-auto" style="color: #409eff">
              <span class="font30">{{ data.ActivityReviewCount }}</span>
              <div class="mt10">待审活动</div>
            </div>
            <div class="home-card-item-icon flex">
              <div class="home-card-item-icon flex" style="background: #f0f9eb">
                <i
                  class="flex-margin el-icon-s-release font32"
                  style="color: #67c23a"
                ></i>
              </div>
            </div>
          </div></div
      ></el-col>
      <el-col
        :span="6"
        class="mb-15"
        :xs="24"
        :sm="12"
        :md="12"
        :lg="6"
        :xl="6"
      >
        <div
          class="home-card-item flex"
          style="cursor: pointer"
          @click="toPage('/person/personapply?state=0')"
        >
          <div class="flex w100">
            <div class="flex-auto" style="color: #409eff">
              <span class="font30">{{ data.PersonReviewCount }}</span>
              <div class="mt10">待审用户</div>
            </div>
            <div class="home-card-item-icon flex" style="background: #ecf5ff">
              <i
                class="flex-margin el-icon-s-order font32"
                style="color: #409eff"
              ></i>
            </div>
          </div></div
      ></el-col>
      <el-col
        :span="6"
        class="mb-15"
        :xs="24"
        :sm="12"
        :md="12"
        :lg="6"
        :xl="6"
      >
        <div class="home-card-item flex">
          <div class="flex w100">
            <div class="flex-auto">
              <span class="font30">{{ data.ResourcesCount }}</span>
              <div class="mt10">合计资源</div>
            </div>
            <div class="home-card-item-icon flex" style="background: #fef0f0">
              <i
                class="flex-margin el-icon-coin font32"
                style="color: #f56c6c"
              ></i>
            </div>
          </div></div
      ></el-col>

      <el-col
        :span="6"
        class="mb-15"
        :xs="24"
        :sm="12"
        :md="12"
        :lg="6"
        :xl="6"
      >
        <div class="home-card-item flex">
          <div class="flex w100">
            <div class="flex-auto">
              <span class="font30">{{ data.ProjectCount }}</span>
              <div class="mt10">合计项目招商</div>
            </div>
            <div class="home-card-item-icon flex" style="background: #fdf6ec">
              <i
                class="flex-margin el-icon-notebook-2 font32"
                style="color: #e6a23c"
              ></i>
            </div>
          </div></div
      ></el-col>
      <el-col
        :span="6"
        class="mb-15"
        :xs="24"
        :sm="12"
        :md="12"
        :lg="6"
        :xl="6"
      >
        <div class="home-card-item flex">
          <div class="flex w100">
            <div class="flex-auto">
              <span class="font30">{{ data.ActivityCount }}</span>
              <div class="mt10">合计活动</div>
            </div>
            <div class="home-card-item-icon flex" style="background: #f0f9eb">
              <i
                class="flex-margin el-icon-goods font32"
                style="color: #67c23a"
              ></i>
            </div>
          </div></div
      ></el-col>

      <el-col
        :span="6"
        class="mb-15"
        :xs="24"
        :sm="12"
        :md="12"
        :lg="6"
        :xl="6"
      >
        <div class="home-card-item flex">
          <div class="flex w100">
            <div class="flex-auto">
              <span class="font30">{{ data.PersonCount }}</span>
              <div class="mt10">合计用户</div>
            </div>
            <div class="home-card-item-icon flex" style="background: #ecf5ff">
              <i
                class="flex-margin el-icon-s-custom font32"
                style="color: #409eff"
              ></i>
            </div>
          </div></div
      ></el-col>
    </el-row>
    <el-row :gutter="20" class="home-card-two">
      <el-col :span="isMB ? 24 : 14">
        <div class="el-col-box" :style="isMB ? 'height:300px' : ''">
          <div>
            <chart :data="PersonStat" v-if="ready" />
          </div>
        </div>
      </el-col>
      <el-col :span="isMB ? 24 : 10">
        <div class="el-col-box">
          <div>
            <chart2 :data="PersontypeStat" v-if="ready" />
          </div>
        </div>
      </el-col>
      <!-- <el-col :span="isMB ? 24 : 8">
        <div class="el-col-box" :style="isMB ? 'height:300px' : ''">
          <div>
            <chart3 :data="SalemoneyStat" v-if="ready" />
          </div>
        </div>
      </el-col> -->
    </el-row>
  </div>
</template>

<script>
import date from "@/components/dashboard/cards/date";
import statistics from "@/components/dashboard/cards/statistics";
import statistics2 from "@/components/dashboard/cards/statistics2";
import chart from "@/components/dashboard/cards/chart";
import chart2 from "@/components/dashboard/cards/chart2";
import chart3 from "@/components/dashboard/cards/chart3";

export default {
  name: "home",
  components: {
    date,
    statistics,
    statistics2,
    chart,
    chart2,
    chart3,
  },
  data() {
    return {
      isMB: this.$store.state.isMB,
      api: require("@/api/sy/user").default,
      timer: null,
      ready: false,
      BusinessShopStat: [],
      BstrinStat: [],
      OrderStat: [],
      PersonStat: [],
      PersontypeStat: [],
      SalemoneyStat: [],
      SaleAmount: 0,
      loginInfo: JSON.parse(localStorage.getItem("loginInfo")),
      data: {
        BusinessReviewCount: 0,
        ApplyCount: 0,
        CrossgoodsCount: 0,
        GeneralgoodsCount: 0,
        BstrinReviewCount: 0,
        BstrcpReviewCount: 0,
        OrderReviewCount: 0,
        BusinessCount: 0,
        BusinessShopCount: 0,
        PersonCount: 0,
        GoodsCount: 0,
        GoodsbondedCount: 0,
        BstrCount: 0,
        LinkCount: 0,
        GoodsTypeCount: 0,
        OrderCount: 0,
        WaitsendorderCount: 0,
        WaitacceptorderCount: 0,
        WaitaftersaleorderCount: 0,
        SaleAmount: 0,
        BusinessShopStat: null,
        BusinessShopStat2: null,
        BstrinStat: null,
        BstrinStat2: null,
        OrderStat: [],
        PersonStat: null,
        SalemoneyStat: null,
        BusinessStat: null,
        ShoptypeStat: null,
        ShoplinkStat: null,
        GoodsOverview: null,
        SaleRanks: null,
        PersontypeStat: [],
        PersonReviewCount: 0,
        ProjectReviewCount: 0,
        ResourcesReviewCount: 0,
        ActivityReviewCount: 0,
        ProjectCount: 0,
        ActivityCount: 0,
        ResourcesCount: 0,
      },
    };
  },
  mounted() {
    this.getTimesFn();
    // let self = this;
    // this.timer = setInterval(function () {
    //   self.getTimesFn();
    // }, 60000);
  },
  methods: {
    getTimesFn() {
      this.api.getWorkbench().then((res) => {
        if (res.Data) {
          this.data = res.Data;
          var SaleAmount = this.data.SaleAmount;
          this.SaleAmount = Number((SaleAmount * 0.0001).toFixed(2));
          if (this.$refs.statistics) {
            this.$refs.statistics.setData(res.Data);
          }
          if (this.$refs.statistics2) {
            this.$refs.statistics2.setData(res.Data);
          }
          this.PersonStat = res.Data.PersonStat;
          this.PersontypeStat = res.Data.PersontypeStat;
          //this.PersonStat = res.Data.PersonStat.reverse();
          //this.SalemoneyStat = res.Data.SalemoneyStat.reverse();
          //  this.BusinessShopStat = res.Data.BusinessShopStat.reverse();
          //  this.BstrinStat = res.Data.BstrinStat.reverse();

          this.ready = true;
        }
      });
    },
    toPage(url) {
      this.$router.push(url);
    },
  },
};
</script>
<style  lang="scss" scoped>
.dashboard-container {
  min-width: 1100px;
  padding: 32px 35px 15px;
  background-color: rgb(240, 242, 245);
  position: relative;
  height: calc(100vh - 84px);
  overflow: auto;
  .mb-15 {
    margin-bottom: 15px;
  }
}
.home-card-item {
  width: 100%;
  height: 130px;
  border-radius: 4px;
  transition: all ease 0.3s;
  padding: 20px;
  overflow: hidden;
  background: #ffffff;
  color: #303133;
  border: 1px solid #f1f2f3;
}
.home-card-two .home-card-item {
  height: 350px;
  width: 100%;
  overflow: hidden;
}
.flex {
  display: flex;
}
.w100 {
  width: 100% !important;
}
.flex-auto {
  flex: 1;
  overflow: hidden;
}
.home-card-item-icon {
  width: 70px;
  height: 70px;
  border-radius: 100%;
  flex-shrink: 1;
}
.font30 {
  font-size: 30px !important;
}
.font32 {
  font-size: 32px !important;
}

.mt10 {
  margin-top: 10px !important;
}
.flex-margin {
  margin: auto;
}
.el-col-box {
  width: 100%;
  border-radius: 4px;
  border: 1px solid #ebeef5;
  background-color: #fff;
  color: #303133;
  -webkit-transition: 0.3s;
  transition: 0.3s;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  min-height: 350px;
  margin-bottom: 20px;
}
.cName {
  font-size: 20px;
  color: #0198ff;
  letter-spacing: 3px;
  text-align: center;
}
.el-col {
  padding: 0 8px !important;
}
</style>